import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/learnerTypography.css';
import './theme/overlay.css';
import './index.css';
import App from './App';
import { isMswEnabled } from 'shared/lib/env';

async function bootstrap() {
  if (isMswEnabled()) {
    const { enableMocking } = await import('shared/api/msw/browser');
    await enableMocking();
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();
